export default function genererLigneOtRemplacement(tfs, ancienneLigne) {
  if (!tfs || !ancienneLigne) return null;
  return {
    produitReference: tfs.produitReference,
    produitId: tfs.produitId,
    affichageId: ancienneLigne.affichageId,
    commentaireAffichage: ancienneLigne.commentaireAffichage,
    affichage: true,
    grattageId: ancienneLigne.grattageId,
    grattage: ancienneLigne.grattage,
    restrictionsAffichage: tfs.restrictionsAffichage,
    pose: ancienneLigne.pose,
    instructionPose: ancienneLigne.instructionPose,
    faceId: tfs.faceId,
    materielId: tfs.materielId,
    format: tfs.format,
    materielNbFace: tfs.materielNbFace,
    materielCode: tfs.materielCode,
    materielDisposition: tfs.materielDisposition,
    dispositifId: tfs.dispositifId,
    dispositifCode: tfs.dispositifCode,
    dispositifAdresse: tfs.dispositifAdresse,
    emplacementId: tfs.emplacementId,
    emplacementCode: tfs.emplacementCode,
    ordre: ancienneLigne.ordre,
    actionLogistique: ancienneLigne.actionLogistique,
    affichagePrecedent: tfs.affichagePrecedent,
    indexRegroupement: ancienneLigne.indexRegroupement,
    tfsId: tfs.id,
    affectationLogistiqueLigneCommandeId: ancienneLigne.affectationLogistiqueLigneCommandeId,
    affectationLogistiqueProduitId: ancienneLigne.affectationLogistiqueProduitId,
    laisserEnPlaceId: ancienneLigne.laisserEnPlaceId,
    laisserEnPlace: false,
  };
}
